export default function Release20231120() {
    return (
        <>
            <p>
                Når der i dag åbnes op for salget af produkter fra Nuuday-selskabet Hiper til 23.000 adresser i det sydfynske,
                betyder det, at private og virksomheder nu får mulighed for lynhurtige fiberprodukter.
            </p>
            <p>
                Vi er rigtig glade for nu at kunne åbne for 23.000 nye husstande via SEF’s fibernetværk. Vi har et benhårdt fokus på at levere lynhurtigt
                og driftssikkert internet til så mange danskere som muligt. Her spiller fiber en stor rolle, da det uden tvivl er den type forbindelse, der
                giver højest hastighed og bedst kvalitet. Om det er til gaming, streaming eller videomøder fra hjemmekontoret, så ved vi, at de fleste danskere
                går op i, at det bare fungerer og er hurtigt.” lyder det fra Mads Hein, direktør for Hiper.
            </p>
            <p>
                <strong>Endnu flere valgmuligheder</strong><br/>
                Samtidig er man hos SEF Fiber glade for at kunderne i Svendborg og omegn samt Langeland nu har endnu flere valgmuligheder, når det kommer til internet og underholdning.
            </p>
            <p>
                "Vi er glade for, at vi kan byde Nuudays stærke fiberbrand Hiper velkommen hos SEF Fiber. Vores ambition er, at vores kunder kan vælge den løsning, der passer bedst
                til dem. Det får de endnu større mulighed for nu, hvor udbuddet igen vokser hos SEF Fiber", udtaler administrerende direktør i SEF Fiber Claus Holm Andersen
            </p>
            <p>
                <strong>Om Nuuday</strong><br/>
                Nuuday består af en række stærke brands, der tilsammen leverer innovative digitale services inden for TV, bredbånd, netværk og telefoni til
                private kunder og virksomheder. YouSee, Telmore, Hiper og eesy servicerer danskere på tværs af alder, køn og bopæl på privatmarkedet.
                På erhvervsmarkedet servicerer Nuuday mindre såvel som store erhvervsvirksomheder med TDC Erhverv og Relatel. Nuuday beskæftiger omkring
                3.700 medarbejdere på tværs af Danmark og har ca. 6 mio. privat- og erhvervskundeforhold.
            </p>
            <p>
                <strong>Om SEF Fiber</strong><br/>
                SEF Fiber er et sydfynsk fiberselskab, der er ejer af fibernettet på Langeland og omkring Svendborg Kommune. Siden 2004 har SEF Fiber udrullet fibernettet til ca.
                23.000 adresser i området. SEF Fiber har i mange år arbejdet på at udbrede det gode internet i de tyndt befolkede områder med dårlig bredbåndsdækning. Ofte etableres
                fiberudrulning som bredbåndspuljeprojekter med støtte fra den statslige bredbåndspulje.
            </p>
        </>
    )
}
